import { useMutation } from "react-query";
import { loggedInApiSingleConcurrentCall } from "src/api/axiosClient/userApi";

export type FillDefaultMultivalueProperty = {
    postId: number | undefined;
    propertyId: number;
    position: number;
};

export const useFillDefaultsMultivalueProperty = () => {
    return useMutation({
        mutationFn: async (options: FillDefaultMultivalueProperty) => {
            const { postId, propertyId, position } = options;

            return await loggedInApiSingleConcurrentCall.post(
                `/api/ssq-posts/${postId}/property/${propertyId}/position/${position}/defaults`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                    },
                },
            );
        },
    });
};
